import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';

import {
  COL_FILTER_HEADER_ACCOUNT,
  COL_FILTER_HEADER_CHILD_ENTITLEMENT,
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  COL_FILTER_HEADER_USER,
} from './constant';

export const getDynamicStyles = (
  totalChildrenCount,
  levelOneChildrenWithChildren,
  level,
  isMobileXlargeWidth,
  isEndPointGroup
) => {
  const isLevelZero = level === 0;
  const isLevelOne = level === 1;
  const isLevelTwo = level === 2;

  if (isLevelTwo) return null;

  const baseHeights = {
    LEVEL_ZERO: 4,
    LEVEL_ONE: 4.0625,
  };

  const additionalHeightPerChildLevel = {
    LEVEL_ZERO: 4,
    LEVEL_ONE: 4,
  };

  let childOffsetZero = 6;
  let childOffsetOne = 6.0625;

  if (isMobileXlargeWidth) {
    childOffsetZero = 4.75;
    childOffsetOne = 5.5;
  }

  if (isEndPointGroup) {
    childOffsetZero = 3.25;
    childOffsetOne = 4.5;
  }

  if (isEndPointGroup && isMobileXlargeWidth) {
    childOffsetZero = 3;
    childOffsetOne = 3.25;
  }

  const hasChildOffSet = {
    LEVEL_ZERO: childOffsetZero,
    LEVEL_ONE: childOffsetOne,
  };

  let height = isLevelZero ? baseHeights.LEVEL_ZERO : baseHeights.LEVEL_ONE;

  if (totalChildrenCount > 0 && isLevelZero) {
    height =
      additionalHeightPerChildLevel.LEVEL_ZERO * totalChildrenCount +
      hasChildOffSet.LEVEL_ZERO;

    if (levelOneChildrenWithChildren > 0)
      height += 2 * levelOneChildrenWithChildren;
  }

  if (totalChildrenCount > 0 && isLevelOne)
    height =
      additionalHeightPerChildLevel.LEVEL_ONE * totalChildrenCount +
      hasChildOffSet.LEVEL_ONE;

  return { height: `${height}rem` };
};

export const getTotalChildrenCount = (node, level) => {
  if (!node?.children || node.children.length === 0)
    return { count: 0, levelOneChildrenWithChildren: 0 };

  let total = node.children.length;
  let levelOneChildrenWithChildren = 0;

  node.children.forEach((child) => {
    const { count, levelOneChildrenWithChildren: childHasChildrenCount } =
      getTotalChildrenCount(child);

    total += count;

    if (level === 0 && child.children?.length > 0)
      levelOneChildrenWithChildren += 1;

    levelOneChildrenWithChildren += childHasChildrenCount;
  });

  return { count: total, levelOneChildrenWithChildren };
};

export const removeChildren = (node) => {
  const rowData = JSON.parse(JSON.stringify(node));

  delete rowData?.children;

  return rowData;
};

export const getNodeDataToViewForTiles = (
  nodeData,
  colsToShow,
  campaignType
) => {
  const filteredObj = {};

  // Determine category based on CERT_ENTITLEMENT_VALUEKEY
  let category;

  const rowType = nodeData?.ROW_TYPE?.toString();

  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  if (isEOCampaign) {
    if (rowType === '0') {
      category = COL_FILTER_HEADER_ENTITLEMENT;
    } else if (rowType === '1') {
      category = COL_FILTER_HEADER_ACCOUNT;
    } else if (rowType === '-1') {
      category = COL_FILTER_HEADER_CHILD_ENTITLEMENT;
    }
  } else if (nodeData.CERT_ENTITLEMENT_VALUEKEY === '0') {
    category = COL_FILTER_HEADER_ACCOUNT;
  } else if (parseInt(nodeData.CERT_ENTITLEMENT_VALUEKEY, 10) > 0) {
    category = COL_FILTER_HEADER_ENTITLEMENT;
  } else if (nodeData.CERT_ENTITLEMENT_VALUEKEY === '-4') {
    category = COL_FILTER_HEADER_USER;
  } else if (nodeData.CERT_ENTITLEMENT_VALUEKEY === '-2') {
    category = COL_FILTER_HEADER_ROLE;
  }

  if (category) {
    const allowedAttributes = colsToShow[category.toUpperCase()];

    allowedAttributes?.forEach((attr) => {
      const realAttr = attr?.split('-')[1];

      if (Object.prototype.hasOwnProperty.call(nodeData, realAttr)) {
        filteredObj[realAttr] = nodeData[realAttr];
      }
    });
  }

  return filteredObj;
};
